(function () {
    function initSlider(ul) {
        const slides = Array.from(ul.children);
        if (slides.length <= 1) return;

        const bloc = ul.closest('.bloc_hdp');
        const pager = bloc ? bloc.querySelector('.hdp_pager') : null;

        let current = 0;
        let interval = null;

        function go(idx) {
            current = (idx + slides.length) % slides.length;
            ul.style.transform = 'translateX(-' + (current * 100) + '%)';
            if (pager) {
                pager.querySelectorAll('.hdp_pager__dot')
                    .forEach((d, i) => d.classList.toggle('is-active', i === current));
            }
        }

        function buildPager() {
            if (!pager) return;
            pager.innerHTML = '';
            slides.forEach((_, i) => {
                const dot = document.createElement('button');
                dot.className = 'hdp_pager__dot' + (i === 0 ? ' is-active' : '');
                dot.setAttribute('aria-label', 'Slide ' + (i + 1));
                dot.addEventListener('click', () => {
                    go(i);
                    resetAutoplay();
                });
                pager.appendChild(dot);
            });
        }

        function resetAutoplay() {
            if (interval) clearInterval(interval);
            interval = setInterval(() => go(current + 1), 6000);
        }

        buildPager();
        go(0);
        resetAutoplay();
    }

    document.querySelectorAll('ul.hdp_slider').forEach(initSlider);
})();